import React, { useEffect, useRef, useState } from 'react';
import Breadcrumb from '@/components/common/Breadcrumb';
import CustomDropdown from '@/components/common/CustomDropdown';
import SidebarDrawer from '@/components/common/SidebarDrawer';
import Card from '@/components/ui/cards/Card';
import CardHeader from '@/components/ui/cards/CardHeader';
import { Input } from '@/components/ui/inputs/input';
import InputRadio from '@/components/ui/inputs/input-radio';
import { InputSelect } from '@/components/ui/inputs/input-select';
import TableWrap from '@/components/ui/tables/TableWrap';
import { cn } from '@/lib/utils';
import TableAddSidebarDrawer from './component/TableAddSidebarDrawer';
import { useDispatch } from 'react-redux';
import { getItemsReportService } from '@/services/ReportServices';
import validationErrors from '@/lib/validationErrors';
import DataTableFilter from './component/DataTableFilter';
import DataTable from './component/DataTable';
import PritntPdfTable from '@/components/common/PritntPdfTable';

const ItemsReportsPage = ({ pageTitle }) => {
    const dispatch = useDispatch();
    const { printTableRef, handleDownloadPdf } = PritntPdfTable('Item Reports');
    const [parPageValue, setParPageValue] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [activeDrawer, setActiveDrawer] = useState(null);
    const [editDataId, setEditDataId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const filterDivRef = useRef(null);
    const [dataFilter, setDataFilter] = useState({
        search: '',
        page: 1,
        limit: 10,
        extra_filter: {},
    });
    const tableColumn = [
        { name: 'Name', isIncludePrint: true },
        { name: 'Category', isIncludePrint: true },
        { name: 'Type', isIncludePrint: true },
        { name: 'Quantity', isIncludePrint: true },
    ];

    useEffect(() => {
        getTableData();
    }, [dataFilter]);

    const getTableData = () => {
        setIsLoading(true);
        dispatch(getItemsReportService(dataFilter))
            .then((res) => {
                console.log({ 'items report': res?.data?.data });
                setTotalRecord(res?.data?.data?.total);
                setDataSource(res?.data?.data?.data);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const handleFilterToggle = () => {
        if (filterDivRef.current) {
            const height = filterDivRef.current.scrollHeight;
            if (!isActive) {
                setIsActive(true);
                filterDivRef.current.style.height = `100%`;
            } else {
                setIsActive(false);
                filterDivRef.current.style.height = '0px';
            }
        }
    };

    const onChangeFilter = (name, value) => {
        if (name == 'extra_filter') {
            let filterObj = value;
            filterObj['tableOrder'] = '';
            setDataFilter({ ...dataFilter, extra_filter: filterObj });
        } else {
            setDataFilter({ ...dataFilter, [name]: value });
        }
    };
    return (
        <>
            <Breadcrumb pageTitle={pageTitle} />
            <Card>
                <CardHeader>
                    <h3 className="db-card-title">{pageTitle}</h3>
                    <div className="db-card-filter">
                        <button className="db-card-filter-btn table-filter-btn" onClick={handleFilterToggle}>
                            <i className="lab lab-filter lab-font-size-14"></i>
                            <span>Filter</span>
                        </button>
                        <CustomDropdown
                            buttonText={'Export'}
                            buttonIcon={'lab-file-export'}
                            dropdownList={[
                                {
                                    icon: 'lab-printer-line',
                                    text: 'Print',
                                    dropDownAction: handleDownloadPdf,
                                },
                                // {
                                //     icon: 'lab-file-excel lab-font-size-15',
                                //     text: 'Excel',
                                // },
                            ]}
                        />
                    </div>
                </CardHeader>
                <div className={cn('table-filter-div', isActive ? 'active' : '')} ref={filterDivRef}>
                    <DataTableFilter onChangeFilter={onChangeFilter} />
                </div>
                <div ref={printTableRef}>
                    <DataTable isLoading={isLoading} tableColumn={tableColumn} dataSource={dataSource} totalRecord={totalRecord} dataFilter={dataFilter} onChangePage={onChangeFilter} />
                </div>
            </Card>
        </>
    );
};

export default ItemsReportsPage;
